export default "__VITE_ASSET__DeM7p8aI__"